/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tutor_Error_UnexpectedInputs */

const en_tutor_error_unexpected = /** @type {(inputs: Tutor_Error_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred`)
};

const fr_tutor_error_unexpected = /** @type {(inputs: Tutor_Error_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur inattendue s'est produite`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred" |
*
* @param {Tutor_Error_UnexpectedInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const tutor_error_unexpected = /** @type {((inputs?: Tutor_Error_UnexpectedInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tutor_Error_UnexpectedInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tutor_error_unexpected(inputs)
	return fr_tutor_error_unexpected(inputs)
});